module.exports = __webpack_public_path__ + "static/img/img-about_jyzx.3ecd40fd.png";